import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  OutlinedInput,
  Typography,
  useTheme,
} from "@mui/material";
import { App } from "antd";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import signInImage from "~/assets/images/signInImage.png";
import temaLogo from "~/assets/images/team-logo.png";
import MDBox from "~/components/MDBox";
import PageLayout from "~/examples/LayoutContainers/PageLayout";
import { useForgetPasswordMutation } from "~/queries/authQueries";

function Cover() {
  const navigate = useNavigate();
  const { message } = App.useApp();
  const theme = useTheme();
  const forgetPasswordMutation = useForgetPasswordMutation();
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Must be a valid email")
        .max(255)
        .required("Email Id is required"),
    }),
    onSubmit: async (values, helpers) => {
      try {
        const { email } = values;
        const response = await forgetPasswordMutation.mutateAsync({ email });

        message.success(response.message);
        navigate("/authentication/sign-in");

        // navigate(config.defaultPath, { replace: true });
      } catch (err) {
        message.error("No User Exists");
        console.log("<< Error >>", err);
        helpers.setStatus({ success: false });
        helpers.setErrors({ submit: "Invalid username" });
        helpers.setSubmitting(false);
      }
    },
  });

  return (
    <PageLayout>
      <Box
        sx={{ height: "100vh" }}
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems="center"
        mt="-20px"
        pb={{ xs: "20px", md: "0px" }}
      >
        <Box
          width={{ xs: "100%", md: "50%", lg: "50%" }}
          display="flex"
          flexDirection="column"
          style={{ userSelect: "none" }}
        >
          <Grid container justifyContent="center">
            <Grid item lg={6}>
              <Grid container direction="column">
                <Grid item>
                  <img
                    src={temaLogo}
                    alt="Team Computers"
                    style={{ height: "40px", width: "90px" }}
                  />
                </Grid>
                <Grid item>
                  <Typography
                    variant="h3"
                    component="div"
                    mb={4}
                    sx={{ color: "#22A699" }}
                  >
                    Reset Password
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    variant="subtitle2"
                    color="textSecondary"
                    fontWeight="bold"
                    fontSize="14px"
                  >
                    You will receive password in e-mail.
                  </Typography>
                </Grid>
              </Grid>
              <MDBox
                component="form"
                role="form"
                noValidate
                onSubmit={formik.handleSubmit}
              >
                <Grid container spacing={2} direction="column">
                  <Grid item lg={4}>
                    <FormControl
                      margin="normal"
                      required
                      fullWidth
                      error={
                        formik.touched.email && Boolean(formik.errors.email)
                      }
                      sx={{ ...theme.typography.customInput }}
                    >
                      <InputLabel htmlFor="email">Email</InputLabel>
                      <OutlinedInput
                        id="email"
                        name="email"
                        autoComplete="email"
                        label="Email"
                        placeholder="Enter your email address"
                        {...formik.getFieldProps("email")}
                        InputLabelProps={{ shrink: true }}
                        error={
                          formik.touched.email && Boolean(formik.errors.email)
                        }
                      />
                      {formik.touched.email && formik.errors.email && (
                        <FormHelperText error>
                          {formik.errors.email}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item lg={4}>
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="inherit"
                      size="large"
                      mt={3}
                      sx={{
                        borderRadius: "16px",
                        bgcolor: "#22A699",
                        color: "#f7f7f7",
                        "&:hover": {
                          backgroundColor: "#1B9C85",
                          color: "InfoText",
                        },
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                  <Grid item lg={4}>
                    <Link to="/authentication/sign-in">
                      <Button
                        variant="contained"
                        color="error"
                        fullWidth
                        size="large"
                        mt={4}
                        sx={{
                          backgroundColor: "#7c0a02",
                          borderRadius: "16px",
                          bgcolor: "#7c0a02",
                          color: "#f7f7f7",
                          "&:hover": {
                            backgroundColor: "#7c0a02",
                            color: "InfoText",
                          },
                        }}
                      >
                        CANCEL
                      </Button>
                    </Link>
                  </Grid>
                </Grid>
              </MDBox>
            </Grid>
          </Grid>
        </Box>

        <Box
          display={{ xs: "none", md: "block" }}
          overflowX="hidden"
          height="100%"
          width="40vw"
          position="absolute"
          right="0px"
        >
          <Box
            style={{
              backgroundImage: `url(${signInImage})`,
              width: "100%",
              height: "100%",
              backgroundSize: "cover",
              backgroundPosition: "50%",
              position: "absolute",
              borderBottomLeftRadius: "20px",
            }}
          ></Box>
        </Box>
      </Box>
    </PageLayout>
  );
}

export default Cover;
